import type { ZodiacSign } from '../types';

export const sportsDict: Record<string, string> = {
  none: 'Не занимаюсь спортом ✖️',
  walking: 'Ходьба 🚶',
  keeping_fit: 'Поддерживаю форму 🏋️',
  active: 'Активный образ жизни 🏃‍♂️',
};

export const interestDict: Record<string, string> = {
  photography: 'Фотография 📷',
  video_editing: 'Видеомонтаж 🎞️',
  design: 'Дизайн 🎨',
  cosmetics: 'Косметика 💄',
  embroidery: 'Вышивание 🪡',
  dancing: 'Танцы 💃',
  singing: 'Пение 🎤',
  music: 'Музыка 🎶',
  blogging: 'Блогинг ✍️',
  drawing: 'Рисование 🖌️',
  running: 'Бег 🏃',
  fitness: 'Фитнес 🏋️',
  cycling: 'Велоспорт 🚴',
  horse_riding: 'Верховая езда 🏇',
  skiing: 'Лыжи 🎿',
  yoga: 'Йога 🧘',
  pilates: 'Пилатес 🤸',
  snowboarding: 'Сноубординг 🏂',
  roller_skating: 'Катание на роликах 🛼',
  skateboarding: 'Скейтбординг 🛹',
  scooter: 'Самокат 🛴',
};

export const alcoholViewDict: Record<string, string> = {
  none: 'Не пью 🚫',
  rarely: 'Редко 🍷',
  often: 'Часто 🍻',
};

export const smokingStatusDict: Record<string, string> = {
  none: 'Не курю 🚭',
  social: 'Курю за компанию 🚬',
  quitting: 'Бросаю 🙅‍♂️',
  smokes: 'Курю постоянно ⛔',
  vapes: 'Использую вейп 💨',
};

export const childrenStatusDict: Record<string, string> = {
  no_children: 'Нет детей 🙅‍♀️',
  no_plans: 'Не планирую детей 🤔',
  has_children: 'Есть дети 👨‍👧‍👦',
  plans_children: 'Планирую детей 👶',
};

export const zodiacSignDict: Record<ZodiacSign, string> = {
  aries: 'Овен ♈',
  taurus: 'Телец ♉',
  gemini: 'Близнецы ♊',
  cancer: 'Рак ♋',
  leo: 'Лев ♌',
  virgo: 'Дева ♍',
  libra: 'Весы ♎',
  scorpio: 'Скорпион ♏',
  sagittarius: 'Стрелец ♐',
  capricorn: 'Козерог ♑',
  aquarius: 'Водолей ♒',
  pisces: 'Рыбы ♓',
};

export const gendersDict = [
  { value: 'male', label: 'Парень' },
  { value: 'female', label: 'Девушка' },
];

export const goalsDict = [
  {
    value: 'serious',
    title: 'Серьезные отношения',
    subtitle: 'Строю планы не только на ближайшие выходные',
  },
  {
    value: 'open',
    title: 'Открытые отношения',
    subtitle: 'Просто и красиво',
  },
  {
    value: 'friendship',
    title: 'Дружбу',
    subtitle: 'Делиться мемами и жизненными историями',
  },
  {
    value: 'new_experience',
    title: 'Новый опыт',
    subtitle: 'Открыть новые эмоции и ощущения',
  },
];

export const goalDisplayDict: Record<string, string> = {
  serious: 'Серьезные отношения ❤️',
  open: 'Открытые отношения 🤗',
  friendship: 'Дружба 🤝',
  new_experience: 'Новый опыт ✨',
};
